<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes js-01 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #js-01 {
    animation-name: js-01;
  }
  @keyframes js-02 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #js-02 {
    animation-name: js-02;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 421.3 865" height="100%" width="100%">>
<g class:paused={isPaused}>
  <g class="shapes" bind:this={rootElement}>
    <g id="js-01">
      <path
        fill="var(--shirt)"
        d="m211 507-6 27a24 24 0 0 1-6 13c-7-2-12 4-19 3-9-2-17 3-25 7-11 0-28 13-31 24-3 0-4 2-6 4-4 7-9 9-17 5-8-5-16-6-26-4l-37 8c-13 3-26 3-34-11l-4-2v-5c4 1 5-2 6-5 9-18 22-30 41-40 23-11 42-29 59-48 11-13 21-26 34-38 7-6 17-10 24-16h2l11 4c8 3 15 7 18 16 1 2 1 7 6 8-1 5 2 7 4 10 6 9 10 19 7 30l-1 10Z"
      />
      <path
        fill="var(--pants)"
        d="m0 581 4 2c8 14 21 14 34 11l38-8c9-2 18-1 26 4 7 4 12 2 16-5 2-2 3-4 6-4l18 8c-4 6-11 10-10 16 1 5 9 7 13 10 5 3 5 6 2 10-9 16-17 33-34 42l-2 4-3 1c-10 11-18 6-28-1-17-13-36-22-52-35-11-9-21-18-28-30Z"
      />
      <path
        fill="var(--hair)"
        d="M140 865c-4-4-10-3-16-6l-33-13c-5-2-7-5-5-10l7-14c5-5 6-13 10-19 4 3 3 7 2 11 0 7 2 11 9 10 5-1 13 1 12-9 0-6 5-7 8-9 1-1 4 0 4-3 4 19 21 24 34 34 5 3 10 3 15 3 4 1 9 1 9 6 1 6-2 9-6 11-7 4-15 4-22 8Z"
      />
      <path
        fill="var(--flesh)"
        d="M138 803c0 3-3 2-4 3-3 2-8 3-7 9 0 10-8 8-13 9-7 1-9-3-9-10 1-4 2-8-2-11 3 0 4-2 5-4 7-15 14-30 18-46l6-20c-12 2-13 2-14-10-1-4-4-5-7-6l8-30c3-12 3-12-8-16l1-4c18-9 26-26 35-42 3-4 3-7-2-10-4-3-12-5-13-10-1-6 6-10 10-16 4 0 10 7 11-2 2-10 4-20 2-30 8-4 16-9 25-7 7 1 12-5 19-3 0 12-3 24-7 35-3 12-5 23-2 35a18 18 0 0 1 1 6c-2 16 6 28 18 38 7 6 6 15 3 23a214 214 0 0 1-11 26c-2 3-2 6 0 9 5 13 9 25 2 38-4 8-7 9-15 5-5-2-11-4-15-7-4-2-6 1-8 4-9 15-19 29-27 44Zm0-88 21-30c1-1 2-3 0-4s-5-2-6 0c-5 11-13 21-15 34Z"
      />
      <path
        fill="var(--hair)"
        d="M166 429h-2c-3-18-11-35-12-54-1-15 8-26 22-29 20-5 41-1 61 0 6 0 7 3 6 8-1 4-4 7-6 10l-9-3c-8-3-11 0-10 8 1 9-4 17-4 26 0 2-2 3-5 3-2 1-3-1-4-3l-2-7c-1-3-3-6-7-6-4-1-6 1-9 4s-2 6-1 10c5 18 4 21-12 30Z"
      />
      <path
        fill="var(--flesh)"
        d="m166 429 6-3c16-9 17-12 12-30-1-4-1-7 1-10s5-5 9-4c4 0 6 3 7 6l2 7c0 2 2 4 4 3 3 0 5-1 5-3 0-9 5-17 4-26-1-8 2-11 10-8l9 3c3 12 1 26 10 37 2 3 2 6 0 9-6 2-1 9-4 12l-1 4-2 2c-5 11-6 12-18 10-5-1-8 1-11 6s-4 10-8 13c-5-1-5-6-6-8-3-9-10-13-18-16l-11-4Z"
      />
      <path
        fill="var(--hair)"
        d="M111 717c3 1 6 2 7 6 2 12 2 12 14 10l-6 20c-7 2-13 5-20 4-12 0-17-6-12-16 4-9 8-18 17-24Z"
      />
    </g>
    <g id="js-02">
      <path
        fill="var(--flesh)"
        d="m288 41-4 24c7 2 13 1 19-5l16-16c3-3 5-6 6-10 0-6 5-9 11-10a58 58 0 0 1 15 1c4 1 10 0 9 4 0 5 1 12-5 15-15 8-22 22-30 36-2 4-6 8-6 13 8 2 17-2 25-2h2c14 1 26-4 36-15 2-3 5-4 10-2 6 2 11 5 18 2 5-1 7 5 11 5v6c-9-1-16 4-24 8-2 1-4 2-3 4s3 1 5 1l9 1c3 0 4 1 4 4s-2 4-4 3c-12 0-23 5-35-1-9-4-17 3-25 5-16 4-31 10-46 16-11 3-23 1-33 7-6-4-10-7-4-14 2-3 1-6 0-8-6-12-10-24-10-38 0-3 0-6-5-6l-29 5c-8 1-15 6-24 5 1-3 5-3 5-6 20 1 27-3 30-19 2-10 6-15 13-13 8 2 5 9 5 15-1 2-1 5 2 6l5-1c4-9 12-14 14-24 2-6 5-7 11-3a19 19 0 0 1 6 7Z"
      />
      <path
        fill="var(--hair)"
        d="M288 41a19 19 0 0 0-7-7c-5-4-8-3-10 3-2 9-10 15-14 24l-5 1c-3-1-3-4-2-6 0-6 3-13-6-15-6-2-10 3-12 13-3 16-10 20-30 19 4-15 4-31 8-46 3-12 10-20 19-27h12c12 5 26 7 37 14 6 4 12 8 19 10 4 2 4 6 1 10-2 4-6 6-10 7Z"
      />
      <path
        fill="var(--shirt)"
        d="M197 79c9 1 16-4 24-5l29-5c5 0 5 3 5 6 0 14 4 26 10 38 1 2 2 5 0 8-6 7-2 10 4 14 0 2 3 6-2 7-16 1-17 11-20 24-4 23-8 45-6 68l5 33a71 71 0 0 1 0 13c0 10-1 10-10 7h-12c-6 0-11 2-16 4-27 11-50 3-72-13-1-3 1-6 3-8 9-14 11-29 12-45l4-83c1-16 5-32 16-46 7-9 16-13 26-17Z"
      />
      <path
        fill="var(--pants)"
        d="M136 278c22 16 45 24 72 13 5-2 10-4 16-4-2 21-2 41-8 62l-22 94c0 3 1 9-6 8 1-3 0-5-3-6l-41-17c-5-2-10-2-13 4-10-4-20-2-31-3 5-21 10-42 10-63-1-16-1-31 2-47s11-29 24-41Z"
      />
      <path
        fill="var(--flesh)"
        d="M131 432c3-6 8-6 13-4l41 17c3 1 4 3 3 6-2 14-9 26-4 41 2 7-3 16-6 23a353 353 0 0 0-23 67l-3 13c-4 13-8 26-9 40-4 7-1 14-1 22l1 12c-2 4-3 9-10 8s-11-4-14-10l-4-15c0-13 2-26-2-39 3-11 2-23 0-34-2-34 12-65 17-97 2-16 5-33 1-50Z"
      />
      <path
        fill="var(--hair)"
        d="m115 652 4 15c3 6 8 9 14 10s8-4 10-8a77 77 0 0 1 8-1c5 0 8 2 5 8-3 3-2 6 0 9 7 14 13 28 24 40 3 3 6 7 3 12-3 6-8 6-13 5a79 79 0 0 1-44-22c-13-12-23-26-33-41-2-3-2-6 1-9 6-8 15-11 21-18ZM143 635c1-14 5-26 9-40 4 6 5 14 10 20l14 17c3 2 6 5 5 9s-7 3-10 3c-10 0-19-5-28-9ZM113 579c2 11 3 23 0 34l-2-2c-17-15-19-15 2-32Z"
      />
    </g>
  </g>
  </g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>